<!-- 公共图片组件 -->
<template>
    <div class="commonImageCard" :style="{ width, height }">
        <img class="commonImage" :src="src" @click="showImage" />
    </div>
</template>

<script>
import { ImagePreview } from 'vant';
export default {
    props: {
        // 图片地址
        src: {
            type: String,
            default: '',
        },
        // 图片宽度
        width: {
            type: String,
            default: '100%',
        },
        // 图片高度
        height: {
            type: String,
            default: 'auto',
        },
    },
    data() {
        return {};
    },
    methods: {
        /**
        * 显示图片预览
        *
        * 该函数用于在弹窗中显示当前图片的预览。
        * 使用ImagePreview组件展示this.src指定的图片。
        */
        showImage() {
            ImagePreview([this.src]);
        },
    },
};
</script>

<style scoped>
.commonImageCard {
    border-radius: 12px;
    overflow: hidden;
    flex-shrink: 0;
}

.commonImage {
    width: 100%;
    height: 100%;
    border-radius: 12px;
    display: block;
}
</style>